import { Links } from '@/shared/constants/navegacao';
import { visaoExibeMeuPerfil } from '@/shared/constants/visao-sistema.constants';
import { useNavigationView } from '@/shared/hooks/useNavigationView';
import { LuChevronDown } from 'react-icons/lu';
import { Link } from 'react-router-dom';

interface AppHeaderUserMenuProps {
  nome?: string | null;
  username?: string | null;
  viewLabel: string;
}

export default function AppHeaderUserMenu({
  nome,
  username,
  viewLabel,
}: AppHeaderUserMenuProps) {
  const { effectiveView } = useNavigationView();
  const exibirMeuPerfil = visaoExibeMeuPerfil(effectiveView);
  const displayName = nome || username || '?';
  const menuId = 'app-header-user-menu';

  return (
    <div className="dropdown app-header__user-menu">
      <button
        type="button"
        className="app-header__user dropdown-toggle"
        id={menuId}
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-haspopup="true"
        title="Menu do usuário"
      >
        <span className="app-header__avatar" aria-hidden>
          {displayName.charAt(0).toUpperCase()}
        </span>
        <span className="app-header__user-text">
          <span className="app-header__user-name">{displayName}</span>
          <span className="app-header__user-role">{viewLabel}</span>
        </span>
        <LuChevronDown className="app-header__user-chevron" size={16} aria-hidden />
      </button>
      <ul className="dropdown-menu dropdown-menu-end" aria-labelledby={menuId}>
        {exibirMeuPerfil && (
          <li>
            <Link className="dropdown-item" to={Links.Usuario_Profile}>
              Meu Perfil
            </Link>
          </li>
        )}
        {exibirMeuPerfil && (
          <li>
            <hr className="dropdown-divider" />
          </li>
        )}
        <li>
          <a className="dropdown-item" href={Links.Auth_Logout}>
            Sair
          </a>
        </li>
      </ul>
    </div>
  );
}
